import React from 'react';

import WizardBreadcrumb from '../WizardBreadcrumb';
import { WizardStepProps } from '../WizardStep';
import { Wrapper } from './styled';

export type WizardWrapperProps = {
  children: Array<Omit<JSX.Element, 'props'> & { props: WizardStepProps }>;
  activeStep: number;
};

const WizardWrapper = ({ children, activeStep }: WizardWrapperProps): JSX.Element => {
  const stepsNames = children.map((step) => step.props.stepName);

  return (
    <Wrapper data-testid="wizard">
      <WizardBreadcrumb activeStep={activeStep} stepsNames={stepsNames} />
      {children[activeStep]}
    </Wrapper>
  );
};

export default WizardWrapper;
